import { Color, MediaBreakpoint } from 'constants/styles'
import styled from 'styled-components'

export const StyledFirstPageLegalNotice = {
  Wrapper: styled.p<{ $inline?: boolean }>`
    position: fixed;
    z-index: 2;
    left: 50%;
    bottom: 12px;
    width: calc(100% - 32px);
    max-width: 328px;

    @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
      max-width: 420px;
    }
    margin: 0;
    transform: translateX(-50%);
    color: ${Color.PRIMARY_TEXT_WITH_OPACITY};
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;

    ${({ $inline }) =>
      $inline &&
      `
      position: static;
      z-index: auto;
      left: auto;
      bottom: auto;
      transform: none;
      margin: 16px auto 0;
    `}
  `,
  Link: styled.a`
    color: inherit;
    cursor: pointer;
    text-decoration: underline;
    white-space: nowrap;
  `,
}
